import { ActionIcon } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import classes from './PeriodNav.module.css';

export interface PeriodNavProps {
  /** Gün ya da ay ("04 Oct 2026 (Sun)", "September 2026"). */
  label: ReactNode;
  previousLabel: string;
  nextLabel: string;
  onPrevious: () => void;
  onNext: () => void;
  previousDisabled?: boolean;
  nextDisabled?: boolean;
}

/**
 * Dönem gezgini (personel-mlc-calisma-dinlenme.jpeg "‹ 04 Oct 2026 (Sun) ›"; M6f G3-20, G3-37):
 * çerçeveli tek denetim, 34 px oklar, iç ayırıcılar. Günlük çizelge, aylık kayıt ve düzenleme
 * penceresi aynı bileşeni kullanır.
 */
export function PeriodNav({
  label,
  previousLabel,
  nextLabel,
  onPrevious,
  onNext,
  previousDisabled = false,
  nextDisabled = false,
}: PeriodNavProps) {
  return (
    <div className={classes.nav}>
      <ActionIcon
        variant="subtle"
        color="navy"
        size={34}
        radius={0}
        className={classes.arrow}
        aria-label={previousLabel}
        disabled={previousDisabled}
        onClick={onPrevious}
      >
        <IconChevronLeft size={16} stroke={2} />
      </ActionIcon>
      <span className={classes.label} aria-live="polite">
        {label}
      </span>
      <ActionIcon
        variant="subtle"
        color="navy"
        size={34}
        radius={0}
        className={classes.arrow}
        aria-label={nextLabel}
        disabled={nextDisabled}
        onClick={onNext}
      >
        <IconChevronRight size={16} stroke={2} />
      </ActionIcon>
    </div>
  );
}
